var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1638",
    "data-name": "Grupo 1638",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223.925,
    height: 172.439,
    viewBox: "0 0 223.925 172.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6340",
    "data-name": "Rect\\xE1ngulo 6340",
    width: 223.925,
    height: 172.439,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6327",
    "data-name": "Rect\\xE1ngulo 6327",
    width: 223.925,
    height: 172.439,
    rx: 25.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6769",
    "data-name": "Trazado 6769",
    d: "M92.956,110.055c-1.992,2.483-.922,8.547-.956,9.593-.539,16.77-14.227,28.076-17.183,36.938-6.183,18.538-5.707,39.435,10.725,52.552,5.367,4.284,15.3,7.573,19.69-1.65,7.3-15.349.542-34.5-1.067-37.7-2.03-4.031-2.125-8.222-4.983-11.428,3.514-10.605,10.091-16.314,9.24-25.683-.441-4.861-.56-10.236-2.609-14.81-1.774-3.964-3.281-8.832-7.71-9.574a5.7,5.7,0,0,0-.945-.08,5.954,5.954,0,0,0-4.2,1.839",
    transform: "translate(-71.159 -108.216)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.265,
    y1: 0.968,
    x2: -0.258,
    y2: 0.968,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efb589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcba0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6330",
    "data-name": "Rect\\xE1ngulo 6330",
    width: 70.908,
    height: 39.308,
    rx: 3.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.463,
    y1: 2.338,
    x2: -0.458,
    y2: 2.338,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9300ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5900aa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6338",
    "data-name": "Rect\\xE1ngulo 6338",
    width: 70.908,
    height: 36.719,
    rx: 3.599,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6337",
    "data-name": "Rect\\xE1ngulo 6337",
    width: 130.474,
    height: 81.421,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8238",
    "data-name": "Grupo 8238",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8222",
    "data-name": "Grupo 8222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8221",
    "data-name": "Grupo 8221",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6759",
    "data-name": "Trazado 6759",
    d: "M14.951,0H208.973a14.951,14.951,0,0,1,14.951,14.951V157.488a14.951,14.951,0,0,1-14.951,14.951H14.951A14.951,14.951,0,0,1,0,157.488V14.951A14.951,14.951,0,0,1,14.951,0",
    fill: "#007eff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8224",
    "data-name": "Grupo 8224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8223",
    "data-name": "Grupo 8223",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6760",
    "data-name": "Trazado 6760",
    d: "M123.568,202.716c9.822-4.532,7.173-5.814,14.237-13.907,3.245-3.717,9.891-16.122,9.837-21.217-.053-4.984-5.84-14.075-9.319-17.078-8.531-7.364-3.589-13.553-12.425-20.5-5.841-4.591-16.938-18.784-24.6-10.022-3.248,3.712-5.539,8.456-8.076,12.61-2.384,3.9-3.5,11.513-7.7,14.029l1.139-.682c-6.164,4.005-12.748,9.038-16.67,15.3a188.357,188.357,0,0,0-10.095,17.264c-2.585,5.33-1.709,10.923-2.834,16.515-1.047,5.207-10.023,15.848-19.757,25.885H99.1c.224-.273.444-.549.672-.819,6.766-8,14.347-13.023,23.8-17.383",
    transform: "translate(-15.429 -48.479)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6761",
    "data-name": "Trazado 6761",
    d: "M186.982,206.239c6.123-1.7,11.247-5.617,17.442-7.242,3.857-1.012,5.142,1.053,8.427,3.244,4.9,3.269,9.964,6.828,14.708,10.379,2.657,1.989,4.948,3.319,1.984,6.142-1.789,1.7-5.069,2.559-7.374,2.926-6.1.97-9.96-1.231-14.852-4.542-.955-.646-2.772-2.384-3.825-2.394-1.629-.015-3.48,2.349-4.574,3.335-2.324,2.094-5.483,6.6-8.758,7.29-2.311.488-1.943-.046-2.371-2.466-.327-1.855-.606-3.646-1.006-5.5-.838-3.9-.527-6.662-.1-10.524C186.977,206.8,186.681,206.17,186.982,206.239Z",
    transform: "translate(-77.047 -82.208)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6762",
    "data-name": "Trazado 6762",
    d: "M192.259,137.082c12.759,1.523,26.16,1.186,38.977,1.836,2.264.115,10.527.467,11.068,2.757,1.609,6.81-13.993,12.231-19.42,11.78-10.926-.91-22.028-2.012-33.165-2.126a36.147,36.147,0,0,1,.953-7.018c.43-2.125,1.789-4.657,1.553-6.769.253-.176-.158-.832.033-.46",
    transform: "translate(-78.48 -56.659)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6763",
    "data-name": "Trazado 6763",
    d: "M142.24,121.889c9.978-3.028,16.755-13.849,26.128-18.233,4.491-2.1,10.8-.762,15.522-.29,5.78.578,11.734.661,17.625.668,2.846,0,5.839-.52,8.8-.675,2.814-.147,5.6-.9,6.449,2.126,1.454,5.184-4.067,10.044-7.968,12.38-5.1,3.053-9.872,3.659-15.809,3.66-4.706,0-10.863-2.9-15.492-1.784-3.4.82-6.959,5.752-9.71,7.829a105.64,105.64,0,0,0-10.263,8.35c-4.141,4-9.758,6.648-12.474,0C143.5,132.136,137.388,123.361,142.24,121.889Z",
    transform: "translate(-58.078 -42.404)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6764",
    "data-name": "Trazado 6764",
    d: "M140.837,164.576c10.348,1.292,20.943-5.838,31.289-6.032,4.959-.092,10.18,3.7,14.3,6.048,5.045,2.878,10.45,5.376,15.83,7.778,2.6,1.16,5.545,1.9,8.311,2.961,2.631,1.01,5.482,1.455,5.025,4.564-.782,5.327-7.8,7.521-12.317,8.069-5.9.715-10.507-.671-15.933-3.086-4.3-1.913-8.742-7.068-13.426-7.929-3.435-.632-8.7,2.425-12.057,3.2a105.605,105.605,0,0,0-12.774,3.455c-5.41,1.97-11.621,2.1-11.4-5.071C137.815,174.448,135.806,163.949,140.837,164.576Z",
    transform: "translate(-56.836 -65.583)",
    fill: "#fbcba0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6765",
    "data-name": "Trazado 6765",
    d: "M191.821,167.541H143.644a8.936,8.936,0,0,1-8.938-8.934V38.778a8.936,8.936,0,0,1,8.939-8.933h48.176a8.936,8.936,0,0,1,8.938,8.933V158.606A8.936,8.936,0,0,1,191.821,167.541Z",
    transform: "translate(-55.723 -12.346)",
    fill: "#32314c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6766",
    "data-name": "Trazado 6766",
    d: "M173.744,41.925a1.563,1.563,0,1,1-1.564,1.563,1.564,1.564,0,0,1,1.564-1.563",
    transform: "translate(-71.224 -17.343)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6767",
    "data-name": "Trazado 6767",
    d: "M191.821,29.844h-9.249q-.711.443-1.4.9c-12.117,8.108-22.539,19.59-26.593,33.591-1.635,5.644-2.2,11.536-3.444,17.279-2.845,13.149-9.184,25.286-16.432,36.627v40.362a8.936,8.936,0,0,0,8.938,8.933h48.177a8.935,8.935,0,0,0,8.937-8.933V38.778A8.935,8.935,0,0,0,191.821,29.844Z",
    transform: "translate(-55.723 -12.345)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6325",
    "data-name": "Rect\\xE1ngulo 6325",
    width: 11.212,
    height: 1.927,
    transform: "matrix(0.992, -0.124, 0.124, 0.992, 106.767, 25.684)",
    fill: "#44446b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6326",
    "data-name": "Rect\\xE1ngulo 6326",
    width: 60.82,
    height: 106.657,
    transform: "translate(81.599 33.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6768",
    "data-name": "Trazado 6768",
    d: "M192.067,43.972h-9.142a.327.327,0,1,1,0-.654h9.142a.327.327,0,1,1,0,.654",
    transform: "translate(-75.534 -17.919)",
    fill: "#9d00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8226",
    "data-name": "Grupo 8226",
    transform: "translate(41.723 63.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8225",
    "data-name": "Grupo 8225",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6328",
    "data-name": "Rect\\xE1ngulo 6328",
    width: 79.896,
    height: 117.02,
    transform: "translate(-38.845 13.947) rotate(-21.007)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8228",
    "data-name": "Grupo 8228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8227",
    "data-name": "Grupo 8227",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6770",
    "data-name": "Trazado 6770",
    d: "M165.906,220.051H146.945a2.792,2.792,0,0,1-2.792-2.792V207.8a2.793,2.793,0,0,1,2.792-2.793h18.961A2.793,2.793,0,0,1,168.7,207.8v9.459a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-59.631 -84.803)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6771",
    "data-name": "Trazado 6771",
    d: "M217.8,220.051H198.841a2.793,2.793,0,0,1-2.792-2.792V207.8a2.793,2.793,0,0,1,2.792-2.793H217.8a2.793,2.793,0,0,1,2.792,2.793v9.459a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-81.098 -84.803)",
    fill: "#9d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6772",
    "data-name": "Trazado 6772",
    d: "M165.906,184.19H146.945a2.792,2.792,0,0,1-2.792-2.792v-9.459a2.793,2.793,0,0,1,2.792-2.793h18.961a2.793,2.793,0,0,1,2.792,2.793V181.4a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-59.631 -69.969)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6773",
    "data-name": "Trazado 6773",
    d: "M217.8,184.19H198.841a2.793,2.793,0,0,1-2.792-2.792v-9.459a2.793,2.793,0,0,1,2.792-2.793H217.8a2.792,2.792,0,0,1,2.792,2.793V181.4a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-81.098 -69.969)",
    fill: "#9d00ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6774",
    "data-name": "Trazado 6774",
    d: "M165.906,148.329H146.945a2.792,2.792,0,0,1-2.792-2.792v-9.459a2.792,2.792,0,0,1,2.792-2.792h18.961a2.792,2.792,0,0,1,2.792,2.792v9.459a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-59.631 -55.135)",
    fill: "#007eff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6775",
    "data-name": "Trazado 6775",
    d: "M217.8,148.329H198.841a2.793,2.793,0,0,1-2.792-2.792v-9.459a2.793,2.793,0,0,1,2.792-2.792H217.8a2.792,2.792,0,0,1,2.792,2.792v9.459a2.792,2.792,0,0,1-2.792,2.792",
    transform: "translate(-81.098 -55.135)",
    fill: "#9d00ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8230",
    "data-name": "Grupo 8230",
    transform: "translate(84.522 35.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8229",
    "data-name": "Grupo 8229",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6776",
    "data-name": "Trazado 6776",
    d: "M98.356,58.447l39.157,47.374,85.456-21.707L183.812,36.739Z",
    transform: "translate(-125.209 -51.626)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8235",
    "data-name": "Grupo 8235",
    transform: "translate(84.522 35.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8234",
    "data-name": "Grupo 8234",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8233",
    "data-name": "Grupo 8233",
    transform: "translate(-25.26 -25.903)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8232",
    "data-name": "Grupo 8232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8231",
    "data-name": "Grupo 8231",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6331",
    "data-name": "Rect\\xE1ngulo 6331",
    width: 45.937,
    height: 34.294,
    transform: "translate(0 55.655) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6332",
    "data-name": "Rect\\xE1ngulo 6332",
    width: 45.303,
    height: 33.661,
    transform: "translate(0.388 55.431) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6333",
    "data-name": "Rect\\xE1ngulo 6333",
    width: 19.687,
    height: 87.64,
    transform: "translate(11.45 58.725) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6334",
    "data-name": "Rect\\xE1ngulo 6334",
    width: 19.054,
    height: 87.007,
    transform: "translate(11.838 58.501) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6335",
    "data-name": "Rect\\xE1ngulo 6335",
    width: 19.687,
    height: 87.64,
    transform: "translate(40.726 19.015) rotate(-74.991)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6336",
    "data-name": "Rect\\xE1ngulo 6336",
    width: 19.054,
    height: 87.007,
    transform: "translate(41.114 18.791) rotate(-74.991)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10.001,
    strokeWidth: 1.08
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8237",
    "data-name": "Grupo 8237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8236",
    "data-name": "Grupo 8236",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6777",
    "data-name": "Trazado 6777",
    d: "M187.858,92.6l3.229-7.15a.19.19,0,0,1,.181-.117h.106a.191.191,0,0,1,.181.117l3.208,7.15a.188.188,0,0,1-.076.254.191.191,0,0,1-.1.022h-.425a.2.2,0,0,1-.181-.117l-.786-1.753h-3.771l-.776,1.753a.2.2,0,0,1-.181.117h-.425a.187.187,0,0,1-.2-.171.192.192,0,0,1,.022-.1M192.9,90.35c-.521-1.158-1.03-2.327-1.551-3.485h-.085l-1.551,3.485Z",
    transform: "translate(-77.7 -35.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6778",
    "data-name": "Trazado 6778",
    d: "M201.77,87.9a1.859,1.859,0,0,1,1.539.753.211.211,0,0,1-.036.3l-.008.006-.2.172c-.161.151-.215.043-.312-.043a1.328,1.328,0,0,0-.99-.452,1.543,1.543,0,0,0-.011,3.078,1.432,1.432,0,0,0,1.141-.56c.129-.129.2-.107.322-.021l.118.086a.216.216,0,0,1,.079.3l0,.006a1.93,1.93,0,0,1-1.648.9,2.212,2.212,0,0,1-2.206-2.218v-.032a2.267,2.267,0,0,1,2.216-2.271",
    transform: "translate(-82.547 -36.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6779",
    "data-name": "Trazado 6779",
    d: "M208.01,87.731h-.549a.2.2,0,0,1-.2-.2V87.29a.2.2,0,0,1,.191-.2h.562V85.891a.212.212,0,0,1,.2-.2l.344-.022a.2.2,0,0,1,.194.2v1.216h1.316a.2.2,0,0,1,.2.191.057.057,0,0,1,0,.014v.236a.2.2,0,0,1-.2.2h-1.316v2.518c0,.43.108.517.355.517a2.054,2.054,0,0,0,.786-.236c.161-.086.2-.022.259.063l.161.269c.076.129.043.193-.076.269A2.815,2.815,0,0,1,209,91.5c-.861,0-.99-.517-.99-1.184Z",
    transform: "translate(-85.734 -35.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6780",
    "data-name": "Trazado 6780",
    d: "M215.826,87.9a2.263,2.263,0,1,1-2.138,2.381c0-.043,0-.087,0-.131a2.206,2.206,0,0,1,2.141-2.25m0,3.82a1.481,1.481,0,0,0,1.4-1.559v-.012a1.405,1.405,0,1,0-2.8,0,1.481,1.481,0,0,0,1.387,1.57h.011",
    transform: "translate(-88.393 -36.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6781",
    "data-name": "Trazado 6781",
    d: "M217.283,97.651h-1.431a.376.376,0,0,1,0-.753h1.431a.376.376,0,0,1,0,.753",
    transform: "translate(-89.135 -40.083)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/touch.f0ee08cd.svg";
export { ForwardRef as ReactComponent };